import React from 'react';
import 'tailwindcss/tailwind.css';
import { Link } from 'react-router-dom';

const FAQ = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      
      <div className="relative h-[600px] bg-black -mt-[100px]">
        <div className="absolute inset-0 bg-gradient-to-r from-black to-transparent z-10"></div>
        <img
          src="https://images.unsplash.com/photo-1632686341231-0a65b83bafaa?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
          alt="FAQ Background"
          className="w-full h-full object-cover opacity-75"
        />
        <div className="absolute top-1/2 left-12 transform -translate-y-1/2 z-20 text-white">
          <h1 className="text-5xl font-bold mb-4">Veel Gestelde Vragen</h1>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="bg-white rounded-lg shadow-md p-8">
          <h2 className="text-3xl font-bold mb-8">Veelgestelde Vragen</h2>

          <div className="mb-6">
            <h3 className="text-xl font-semibold">Wanneer zijn jullie geopend?</h3> 
            <p className="text-gray-600">Wij zijn uitsluitend op afspraak geopend. In het weekend en in de avonduren kunnen we mogelijkheden creëren voor een bezichtiging en proefrit maar eventueel ook doordeweeks tijdens kantooruren.</p>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-semibold">Kan ik de auto direct meenemen?</h3>
            <p className="text-gray-600">De meeste auto’s zijn al rijklaar en kunnen daarom ook direct mee naar huis worden genomen.</p>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-semibold">Moeten we naar het postkantoor om de auto over te schrijven?</h3>
            <p className="text-gray-600">Nee, wij kunnen uw nieuwe auto direct ter plekke overschrijven. Mocht u uw auto willen inruilen dan kunnen wij deze met hetzelfde gemak ook vrijwaren.</p>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-semibold">Wat moet ik meenemen om de auto direct te kunnen overschrijven?</h3>
            <p className="text-gray-600">Hiervoor moet u uw Nederlandse rijbewijs of Nederlandse identiteitskaart/ paspoort meenemen.</p>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-semibold">Ik ga mijn auto inruilen, wat moet ik meenemen zodat jullie de auto kunnen vrijwaren?</h3>
            <p className="text-gray-600">Voor de vrijwaring van uw huidige auto hebben wij de volgende zaken nodig:</p>
            <ul className="list-disc list-inside text-gray-600">
              <li>Kentekenpas</li>
              <li>Eerste tenaamstellingscode</li>
              <li>Tweede tenaamstellingscode</li>
            </ul>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-semibold">Wat is het verschil tussen een marge en BTW auto?</h3>
            <p className="text-gray-600">Als u de auto particulier koopt dan maakt dit geen verschil. Voor een ondernemer die de auto zakelijk wil gaan rijden ligt dit anders.</p>
          </div>

          <div class Name="mb-6">
            <h3 className="text-xl font-semibold">Kan ik mijn auto ook aan jullie verkopen zonder een auto terug te kopen?</h3>
            <p className="text-gray-600">U mag uw huidige auto altijd aan ons aanbieden. Wij zullen de auto dan controleren en beoordelen of hij binnen onze voorraad past.</p>
          </div>

          <div className="mb-6">
            <h3 className="text-xl font-semibold">Mijn vraag staat er niet tussen, wat nu?</h3>
            <p className="text-gray-600">U mag ons altijd bellen, mailen of een whatsapp sturen. Wij helpen u graag verder.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;